import { render } from "./AccessibilityDialogueOnDashboard.vue?vue&type=template&id=0368adbb&scoped=true"
import script from "./AccessibilityDialogueOnDashboard.vue?vue&type=script&lang=js"
export * from "./AccessibilityDialogueOnDashboard.vue?vue&type=script&lang=js"

import "./AccessibilityDialogueOnDashboard.vue?vue&type=style&index=0&id=0368adbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0368adbb"]])

export default __exports__